import type { CSSProperties } from "react";
import styled from "styled-components";

type HorizontalDividerProps = {
  margin: CSSProperties["margin"];
};
export const HorizontalDivider = styled.span<HorizontalDividerProps>`
  margin: ${({ margin }) => margin};
  border-bottom: 1px solid
    var(--sinch-sys-color-container-contrast-primary-active);
  display: block;
`;

export const DropdownItemDivider = styled.span`
  display: block;
  height: 1px;
  background: var(--sinch-sys-color-container-contrast-primary-default);
`;
